import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneServicePayload } from '@app-store/slices/services/oneService'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneServicePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.services.oneService

function* oneServiceSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/services/one/${payload.serviceId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneServiceSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneServiceSagaTask)
}

export default oneServiceSaga
